import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import AddAssistance from './AddAssistance';

export default withUser(withRouter(AddAssistance));
